const countryList = [
  [
    'af',
    'Afghanistan'
  ],
  [
    'ax',
    'Akrotiri'
  ],
  [
    'al',
    'Albania'
  ],
  [
    'ag',
    'Algeria'
  ],
  [
    'aq',
    'American Samoa'
  ],
  [
    'an',
    'Andorra'
  ],
  [
    'ao',
    'Angola'
  ],
  [
    'av',
    'Anguilla'
  ],
  [
    'ac',
    'Antigua and Barbuda'
  ],
  [
    'ar',
    'Argentina'
  ],
  [
    'am',
    'Armenia'
  ],
  [
    'aa',
    'Aruba'
  ],
  [
    'at',
    'Ashmore and Cartier Islands'
  ],
  [
    'as',
    'Australia'
  ],
  [
    'au',
    'Austria'
  ],
  [
    'aj',
    'Azerbaijan'
  ],
  [
    'bf',
    'Bahamas'
  ],
  [
    'ba',
    'Bahrain'
  ],
  [
    'bg',
    'Bangladesh'
  ],
  [
    'bb',
    'Barbados'
  ],
  [
    'bo',
    'Belarus'
  ],
  [
    'be',
    'Belgium'
  ],
  [
    'bh',
    'Belize'
  ],
  [
    'bn',
    'Benin'
  ],
  [
    'bd',
    'Bermuda'
  ],
  [
    'bt',
    'Bhutan'
  ],
  [
    'bl',
    'Bolivia'
  ],
  [
    'bk',
    'Bosnia and Herzegovina'
  ],
  [
    'bc',
    'Botswana'
  ],
  [
    'bv',
    'Bouvet Island'
  ],
  [
    'br',
    'Brazil'
  ],
  [
    'io',
    'British Indian Ocean Territory'
  ],
  [
    'vi',
    'British Virgin Islands'
  ],
  [
    'bx',
    'Brunei'
  ],
  [
    'bu',
    'Bulgaria'
  ],
  [
    'uv',
    'Burkina Faso'
  ],
  [
    'bm',
    'Burma'
  ],
  [
    'by',
    'Burundi'
  ],
  [
    'cv',
    'Cabo Verde'
  ],
  [
    'cb',
    'Cambodia'
  ],
  [
    'cm',
    'Cameroon'
  ],
  [
    'ca',
    'Canada'
  ],
  [
    'cj',
    'Cayman Islands'
  ],
  [
    'ct',
    'Central African Republic'
  ],
  [
    'cd',
    'Chad'
  ],
  [
    'ci',
    'Chile'
  ],
  [
    'cn',
    'China'
  ],
  [
    'kt',
    'Christmas Island'
  ],
  [
    'ip',
    'Clipperton Island'
  ],
  [
    'ck',
    'Cocos (Keeling) Islands'
  ],
  [
    'co',
    'Colombia'
  ],
  [
    'km',
    'Comoros'
  ],
  [
    'cg',
    'Congo, Democratic Republic of the'
  ],
  [
    'cf',
    'Congo, Republic of the'
  ],
  [
    'cw',
    'Cook Islands'
  ],
  [
    'cr',
    'Coral Sea Islands'
  ],
  [
    'cs',
    'Costa Rica'
  ],
  [
    'iv',
    'Cote d\'Ivoire'
  ],
  [
    'hr',
    'Croatia'
  ],
  [
    'cu',
    'Cuba'
  ],
  [
    'cc',
    'Curacao'
  ],
  [
    'cy',
    'Cyprus'
  ],
  [
    'ez',
    'Czech Republic'
  ],
  [
    'da',
    'Denmark'
  ],
  [
    'dx',
    'Dhekelia'
  ],
  [
    'dj',
    'Djibouti'
  ],
  [
    'do',
    'Dominica'
  ],
  [
    'dr',
    'Dominican Republic'
  ],
  [
    'ec',
    'Ecuador'
  ],
  [
    'eg',
    'Egypt'
  ],
  [
    'es',
    'El Salvador'
  ],
  [
    'ek',
    'Equatorial Guinea'
  ],
  [
    'er',
    'Eritrea'
  ],
  [
    'en',
    'Estonia'
  ],
  [
    'et',
    'Ethiopia'
  ],
  [
    'fk',
    'Falkland Islands (Islas Malvinas)'
  ],
  [
    'fo',
    'Faroe Islands'
  ],
  [
    'fj',
    'Fiji'
  ],
  [
    'fi',
    'Finland'
  ],
  [
    'fr',
    'France'
  ],
  [
    'fp',
    'French Polynesia'
  ],
  [
    'fs',
    'French Southern and Antarctic Lands'
  ],
  [
    'gb',
    'Gabon'
  ],
  [
    'ga',
    'Gambia, The'
  ],
  [
    'gg',
    'Georgia'
  ],
  [
    'gm',
    'Germany'
  ],
  [
    'gh',
    'Ghana'
  ],
  [
    'gi',
    'Gibraltar'
  ],
  [
    'gr',
    'Greece'
  ],
  [
    'gl',
    'Greenland'
  ],
  [
    'gj',
    'Grenada'
  ],
  [
    'gq',
    'Guam'
  ],
  [
    'gt',
    'Guatemala'
  ],
  [
    'gk',
    'Guernsey'
  ],
  [
    'gv',
    'Guinea'
  ],
  [
    'pu',
    'Guinea-Bissau'
  ],
  [
    'gy',
    'Guyana'
  ],
  [
    'ha',
    'Haiti'
  ],
  [
    'hm',
    'Heard Island and McDonald Islands'
  ],
  [
    'vt',
    'Holy See (Vatican City)'
  ],
  [
    'ho',
    'Honduras'
  ],
  [
    'hk',
    'Hong Kong'
  ],
  [
    'hu',
    'Hungary'
  ],
  [
    'ic',
    'Iceland'
  ],
  [
    'in',
    'India'
  ],
  [
    'id',
    'Indonesia'
  ],
  [
    'ir',
    'Iran'
  ],
  [
    'iz',
    'Iraq'
  ],
  [
    'ei',
    'Ireland'
  ],
  [
    'im',
    'Isle of Man'
  ],
  [
    'is',
    'Israel'
  ],
  [
    'it',
    'Italy'
  ],
  [
    'jm',
    'Jamaica'
  ],
  [
    'jn',
    'Jan Mayen'
  ],
  [
    'ja',
    'Japan'
  ],
  [
    'je',
    'Jersey'
  ],
  [
    'jo',
    'Jordan'
  ],
  [
    'kz',
    'Kazakhstan'
  ],
  [
    'ke',
    'Kenya'
  ],
  [
    'kr',
    'Kiribati'
  ],
  [
    'kn',
    'Korea, North'
  ],
  [
    'ks',
    'Korea, South'
  ],
  [
    'kv',
    'Kosovo'
  ],
  [
    'ku',
    'Kuwait'
  ],
  [
    'kg',
    'Kyrgyzstan'
  ],
  [
    'la',
    'Laos'
  ],
  [
    'lg',
    'Latvia'
  ],
  [
    'le',
    'Lebanon'
  ],
  [
    'lt',
    'Lesotho'
  ],
  [
    'li',
    'Liberia'
  ],
  [
    'ly',
    'Libya'
  ],
  [
    'ls',
    'Liechtenstein'
  ],
  [
    'lh',
    'Lithuania'
  ],
  [
    'lu',
    'Luxembourg'
  ],
  [
    'mc',
    'Macau'
  ],
  [
    'mk',
    'Macedonia'
  ],
  [
    'ma',
    'Madagascar'
  ],
  [
    'mi',
    'Malawi'
  ],
  [
    'my',
    'Malaysia'
  ],
  [
    'mv',
    'Maldives'
  ],
  [
    'ml',
    'Mali'
  ],
  [
    'mt',
    'Malta'
  ],
  [
    'rm',
    'Marshall Islands'
  ],
  [
    'mr',
    'Mauritania'
  ],
  [
    'mp',
    'Mauritius'
  ],
  [
    'mx',
    'Mexico'
  ],
  [
    'fm',
    'Micronesia, Federated States of'
  ],
  [
    'md',
    'Moldova'
  ],
  [
    'mn',
    'Monaco'
  ],
  [
    'mg',
    'Mongolia'
  ],
  [
    'mj',
    'Montenegro'
  ],
  [
    'mh',
    'Montserrat'
  ],
  [
    'mo',
    'Morocco'
  ],
  [
    'mz',
    'Mozambique'
  ],
  [
    'wa',
    'Namibia'
  ],
  [
    'nr',
    'Nauru'
  ],
  [
    'bq',
    'Navassa Island'
  ],
  [
    'np',
    'Nepal'
  ],
  [
    'nl',
    'Netherlands'
  ],
  [
    'nc',
    'New Caledonia'
  ],
  [
    'nz',
    'New Zealand'
  ],
  [
    'nu',
    'Nicaragua'
  ],
  [
    'ng',
    'Niger'
  ],
  [
    'ni',
    'Nigeria'
  ],
  [
    'ne',
    'Niue'
  ],
  [
    'nf',
    'Norfolk Island'
  ],
  [
    'cq',
    'Northern Mariana Islands'
  ],
  [
    'no',
    'Norway'
  ],
  [
    'mu',
    'Oman'
  ],
  [
    'pk',
    'Pakistan'
  ],
  [
    'ps',
    'Palau'
  ],
  [
    'pm',
    'Panama'
  ],
  [
    'pp',
    'Papua New Guinea'
  ],
  [
    'pa',
    'Paraguay'
  ],
  [
    'pe',
    'Peru'
  ],
  [
    'rp',
    'Philippines'
  ],
  [
    'pc',
    'Pitcairn Islands'
  ],
  [
    'pl',
    'Poland'
  ],
  [
    'po',
    'Portugal'
  ],
  [
    'rq',
    'Puerto Rico'
  ],
  [
    'qa',
    'Qatar'
  ],
  [
    'ro',
    'Romania'
  ],
  [
    'rs',
    'Russia'
  ],
  [
    'rw',
    'Rwanda'
  ],
  [
    'tb',
    'Saint Barthelemy'
  ],
  [
    'sh',
    'Saint Helena, Ascension, and Tristan da Cunha'
  ],
  [
    'sc',
    'Saint Kitts and Nevis'
  ],
  [
    'st',
    'Saint Lucia'
  ],
  [
    'rn',
    'Saint Martin'
  ],
  [
    'sb',
    'Saint Pierre and Miquelon'
  ],
  [
    'vc',
    'Saint Vincent and the Grenadines'
  ],
  [
    'ws',
    'Samoa'
  ],
  [
    'sm',
    'San Marino'
  ],
  [
    'tp',
    'Sao Tome and Principe'
  ],
  [
    'sa',
    'Saudi Arabia'
  ],
  [
    'sg',
    'Senegal'
  ],
  [
    'ri',
    'Serbia'
  ],
  [
    'se',
    'Seychelles'
  ],
  [
    'sl',
    'Sierra Leone'
  ],
  [
    'sn',
    'Singapore'
  ],
  [
    'sk',
    'Sint Maarten'
  ],
  [
    'lo',
    'Slovakia'
  ],
  [
    'si',
    'Slovenia'
  ],
  [
    'bp',
    'Solomon Islands'
  ],
  [
    'so',
    'Somalia'
  ],
  [
    'sf',
    'South Africa'
  ],
  [
    'sx',
    'South Georgia and South Sandwich Islands'
  ],
  [
    'od',
    'South Sudan'
  ],
  [
    'sp',
    'Spain'
  ],
  [
    'ce',
    'Sri Lanka'
  ],
  [
    'su',
    'Sudan'
  ],
  [
    'ns',
    'Suriname'
  ],
  [
    'sv',
    'Svalbard'
  ],
  [
    'wz',
    'Swaziland'
  ],
  [
    'sw',
    'Sweden'
  ],
  [
    'sz',
    'Switzerland'
  ],
  [
    'sy',
    'Syria'
  ],
  [
    'tw',
    'Taiwan'
  ],
  [
    'ti',
    'Tajikistan'
  ],
  [
    'tz',
    'Tanzania'
  ],
  [
    'th',
    'Thailand'
  ],
  [
    'tt',
    'Timor-Leste'
  ],
  [
    'to',
    'Togo'
  ],
  [
    'tl',
    'Tokelau'
  ],
  [
    'tn',
    'Tonga'
  ],
  [
    'td',
    'Trinidad and Tobago'
  ],
  [
    'ts',
    'Tunisia'
  ],
  [
    'tu',
    'Turkey'
  ],
  [
    'tx',
    'Turkmenistan'
  ],
  [
    'tk',
    'Turks and Caicos Islands'
  ],
  [
    'tv',
    'Tuvalu'
  ],
  [
    'ug',
    'Uganda'
  ],
  [
    'up',
    'Ukraine'
  ],
  [
    'ae',
    'United Arab Emirates'
  ],
  [
    'uk',
    'United Kingdom'
  ],
  [
    'us',
    'United States'
  ],
  [
    'um',
    'United States Pacific Island Wildlife Refuges'
  ],
  [
    'uy',
    'Uruguay'
  ],
  [
    'uz',
    'Uzbekistan'
  ],
  [
    'nh',
    'Vanuatu'
  ],
  [
    've',
    'Venezuela'
  ],
  [
    'vm',
    'Vietnam'
  ],
  [
    'vq',
    'Virgin Islands'
  ],
  [
    'wq',
    'Wake Island'
  ],
  [
    'wf',
    'Wallis and Futuna'
  ],
  [
    'ym',
    'Yemen'
  ],
  [
    'za',
    'Zambia'
  ],
  [
    'zi',
    'Zimbabwe'
  ],
  [
    'ee',
    'European Union'
  ]
]

const getCountryName = (code) => {
  if (!code) return 'hacker'
  code = code.toLowerCase()
  for (let e of countryList) {
    if (e[0] === code) return e[1]
  }

  return 'hacker'
}

export default countryList

export { getCountryName }



// WEBPACK FOOTER //
// ./src/utils/country.js